export const NOTIFICATION_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error'
};
